// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader@0.28.11/node_modules/css-loader/index.js?sourceMap!./keen-slider.min.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("3576aba0", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/keen-slider@6.8.5/node_modules/keen-slider/keen-slider.min.css
// module id = 2377
// module chunks = 4